import { value } from '@takeshape/util';
import { updateAuthentication } from "../util/authentication.js";
import { isCompleteGraphQLConfig } from "../util/config.js";
import { getHealthCheck } from "../util/health.js";
const serviceProvider = {
    name: 'hygraph',
    title: 'Hygraph',
    description: 'Hygraph gives you instant GraphQL Content APIs to create, enrich, unify, and deliver your content across platforms.',
    categories: ['content'],
    links: [{ title: 'Homepage', url: 'https://hygraph.com/' }],
    serviceType: 'graphql',
    introspectionType: 'graphql',
    createId: value('hygraph'),
    getFormSchema: value({
        type: 'object',
        properties: {
            id: {
                title: 'Slug',
                type: 'string',
                pattern: '[0-9A-Za-z_-]+',
                default: 'Hygraph'
            },
            title: {
                title: 'Name',
                type: 'string',
                default: 'hygraph'
            },
            namespace: {
                title: 'Namespace',
                type: 'string',
                pattern: '^[A-Z][A-Za-z]+$',
                default: 'Hygraph'
            },
            endpoint: {
                title: 'Endpoint',
                type: 'string',
                pattern: '^https://[a-zA-z0-9-]+\\.hygraph.com/v\\d/[a-zA-z0-9]+/[a-zA-z0-9-]+$'
            },
            authentication: {
                title: 'Authentication',
                type: 'object',
                properties: {
                    token: {
                        title: 'Auth Token',
                        type: 'string',
                        '@sensitive': true
                    }
                },
                required: ['token']
            }
        },
        required: ['title', 'id', 'namespace', 'endpoint', 'authentication']
    }),
    getFormConfig: value({
        order: ['title', 'id', 'namespace', 'endpoint', 'authentication'],
        properties: {
            title: {
                widget: 'singleLineText',
                instructions: 'Human-readable identifier for use in the UI.'
            },
            namespace: {
                widget: 'singleLineText',
                instructions: 'A pascal-case prefix that will be added to types in your Hygraph API.'
            },
            id: {
                widget: 'singleLineText',
                instructions: 'Unique identifier for use in the API and Schema.'
            },
            endpoint: {
                widget: 'singleLineText',
                instructions: 'Content API URL e.g. "https://[region].hygraph.com/v2/[projectId]/[environment]"'
            },
            authentication: {
                properties: {
                    token: {
                        widget: 'sensitiveField',
                        instructions: 'Permanent auth token from your Hygraph account'
                    }
                },
                order: ['token']
            }
        }
    }),
    getConfig(formData) {
        const config = {
            title: formData.title ?? 'Hygraph',
            namespace: formData.namespace ?? 'Hygraph',
            provider: 'hygraph',
            serviceType: 'graphql',
            authenticationType: 'bearer',
            options: {
                endpoint: formData.endpoint
            }
        };
        return updateAuthentication(config, formData, { type: 'bearer' });
    },
    isCompleteConfig: isCompleteGraphQLConfig,
    getHealthCheck: getHealthCheck({ checkName: 'graphqlIntrospection' })
};
export default serviceProvider;
